<div *transloco="let t; read: 'features.validateCoupon'" class="table-custom-wrapper">
  <h4 class="fw-bold">{{ t("details") }}</h4>
  <table class="table-custom table-nowrap mb-0">
    <tbody>
      <ng-container *ngTemplateOutlet="detailsTemplate; context: { details: generalDetails }"></ng-container>
    </tbody>
  </table>

  <h4 *ngIf="hasAdditionalDetails" class="fw-bold">{{ t("additionalDetails") }}</h4>
    <table class="table-custom table-nowrap mb-0">
      <tbody>
        <ng-container *ngTemplateOutlet="detailsTemplate; context: { details: additionalDetails }"></ng-container>
      </tbody>
    </table>
</div>


<ng-template #detailsTemplate let-details="details">
  <tr *ngFor="let detail of details | keyvalue" class="table-custom__row">
    <th class="table-custom__title" scope="row">{{ detail.key }}</th>
    <td class="table-custom__value">
      <span class="table-custom__value-text">
        {{ detail.value }}
      </span>
    </td>
  </tr>
</ng-template>
